import { defineComponent, ref, computed, watch, onUnmounted, createBlock, openBlock, resolveDynamicComponent, normalizeClass, withCtx, createElementBlock, createCommentVNode, createElementVNode, createVNode, renderSlot, createTextVNode, Transition, Fragment, toDisplayString } from 'vue';
import _sfc_main$1 from './basler-components.es81.js';
/* empty css                       */

const _hoisted_1 = {
  key: 0,
  class: "button__animated-border-box"
};
const _hoisted_2 = { class: "button__content" };
const _hoisted_3 = {
  key: 1,
  class: "button__text"
};
const _hoisted_4 = {
  key: 0,
  class: "button__content button__content--state"
};
const _hoisted_5 = {
  key: 0,
  class: "button__text"
};
const _hoisted_6 = {
  key: 1,
  "aria-hidden": "true",
  class: "button__text"
};
const _hoisted_7 = {
  class: "visually-hidden",
  "aria-live": "polite",
  "aria-atomic": "true"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Button",
  props: {
    tag: { default: "button" },
    styleType: { default: "secondary" },
    iconType: { default: "no-icon" },
    active: { type: Boolean, default: false },
    size: { default: "medium" },
    iconName: { default: "" },
    iconScale: { default: 1 },
    disabled: { type: Boolean, default: false },
    expand: { type: Boolean },
    states: {},
    activeState: {}
  },
  emits: ["click", "update:activeState"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const internalActiveState = ref(props.activeState);
    const announcementText = ref("");
    let resetTimer = null;
    const DEFAULT_STATES = {
      loading: {
        ariaText: "Loading",
        resetDelay: 3e3
      },
      success: {
        text: "Success!",
        ariaText: "Action completed successfully",
        resetDelay: 2e3
      },
      error: {
        text: "Error",
        ariaText: "Something went wrong",
        resetDelay: 3e3
      }
    };
    const mergedStates = computed(() => {
      if (!props.states) {
        return { ...DEFAULT_STATES };
      }
      const result = {};
      for (const stateKey of Object.keys(props.states)) {
        if (props.states[stateKey] !== void 0 && stateKey in DEFAULT_STATES) {
          result[stateKey] = {
            ...DEFAULT_STATES[stateKey],
            ...props.states[stateKey]
          };
        }
      }
      return result;
    });
    const currentStateConfig = computed(() => {
      const state = internalActiveState.value;
      if (state && state !== "initial") {
        return mergedStates.value[state];
      }
      return null;
    });
    const stateIconName = computed(() => {
      if (internalActiveState.value === "loading") {
        return "state-loading";
      } else if (internalActiveState.value === "success") {
        return "state-success";
      } else if (internalActiveState.value === "error") {
        return "state-error";
      }
      return null;
    });
    const isLoading = computed(() => internalActiveState.value === "loading");
    const isDisabled = computed(
      () => props.disabled || internalActiveState.value && internalActiveState.value !== "initial"
    );
    const cssClassNames = computed(() => {
      const classes = ["button", `button--${props.iconType}`, `button--${props.styleType}`, `button--${props.size}`];
      if (props.active) {
        classes.push("is-active");
      }
      if (props.expand) {
        classes.push("button--expanded");
      }
      if (internalActiveState.value) {
        classes.push(`button--has-states`);
        classes.push(`button--state-${internalActiveState.value}`);
      }
      if (internalActiveState.value && internalActiveState.value !== "initial") {
        classes.push("button--has-active-state");
      }
      return classes;
    });
    watch(
      () => props.activeState,
      (newState) => {
        if (newState !== internalActiveState.value) {
          internalActiveState.value = newState;
        }
      },
      { immediate: true }
    );
    watch(
      internalActiveState,
      (newState) => {
        if (resetTimer) {
          clearTimeout(resetTimer);
          resetTimer = null;
        }
        if (newState !== "initial" && currentStateConfig.value?.ariaText) {
          announcementText.value = currentStateConfig.value?.ariaText;
        } else {
          announcementText.value = "";
        }
        if (newState && newState !== "initial") {
          const stateConfig = mergedStates.value[newState];
          const resetDelay = stateConfig?.resetDelay;
          if (resetDelay && resetDelay > 0) {
            resetTimer = setTimeout(() => {
              internalActiveState.value = "initial";
              emit("update:activeState", internalActiveState.value);
              resetTimer = null;
            }, resetDelay);
          }
        }
      },
      { immediate: true }
    );
    const onClick = (event) => {
      if (isDisabled.value || internalActiveState.value && internalActiveState.value !== "initial") {
        event.preventDefault();
        return;
      }
      emit("click", event);
      if (internalActiveState.value === "initial" && "loading" in mergedStates.value) {
        internalActiveState.value = "loading";
        emit("update:activeState", internalActiveState.value);
      }
    };
    onUnmounted(() => {
      if (resetTimer) {
        clearTimeout(resetTimer);
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.tag), {
        type: _ctx.tag === "button" ? "button" : void 0,
        class: normalizeClass(cssClassNames.value),
        disabled: _ctx.disabled || void 0,
        "aria-busy": isLoading.value || void 0,
        "aria-disabled": isDisabled.value || void 0,
        onClick
      }, {
        default: withCtx(() => [
          _ctx.styleType === "remarkable" ? (openBlock(), createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
            createElementVNode("div", { class: "button__animated-border-trail" }, null, -1)
          ]))) : createCommentVNode("", true),
          createElementVNode("span", _hoisted_2, [
            _ctx.iconType === "icon-left" && _ctx.iconName ? (openBlock(), createBlock(_sfc_main$1, {
              key: 0,
              name: _ctx.iconName,
              "scale-factor": _ctx.iconScale
            }, null, 8, ["name", "scale-factor"])) : createCommentVNode("", true),
            _ctx.iconType !== "icon-only" ? (openBlock(), createElementBlock("span", _hoisted_3, [
              renderSlot(_ctx.$slots, "default", {}, () => [
                _cache[1] || (_cache[1] = createTextVNode("Button"))
              ])
            ])) : _ctx.iconName ? (openBlock(), createBlock(_sfc_main$1, {
              key: 2,
              name: _ctx.iconName,
              "scale-factor": _ctx.iconScale
            }, null, 8, ["name", "scale-factor"])) : createCommentVNode("", true),
            _ctx.iconType === "icon-right" && _ctx.iconName ? (openBlock(), createBlock(_sfc_main$1, {
              key: 3,
              name: _ctx.iconName,
              "scale-factor": _ctx.iconScale
            }, null, 8, ["name", "scale-factor"])) : createCommentVNode("", true)
          ]),
          createVNode(Transition, null, {
            default: withCtx(() => [
              currentStateConfig.value ? (openBlock(), createElementBlock("span", _hoisted_4, [
                stateIconName.value ? (openBlock(), createBlock(_sfc_main$1, {
                  key: 0,
                  name: stateIconName.value
                }, null, 8, ["name"])) : createCommentVNode("", true),
                !currentStateConfig.value?.hideText ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  currentStateConfig.value?.text ? (openBlock(), createElementBlock("span", _hoisted_5, toDisplayString(currentStateConfig.value.text), 1)) : (openBlock(), createElementBlock("span", _hoisted_6, [
                    renderSlot(_ctx.$slots, "default")
                  ]))
                ], 64)) : createCommentVNode("", true)
              ])) : createCommentVNode("", true)
            ]),
            _: 3
          }),
          createElementVNode("div", _hoisted_7, toDisplayString(announcementText.value), 1)
        ]),
        _: 3
      }, 8, ["type", "class", "disabled", "aria-busy", "aria-disabled"]);
    };
  }
});

export { _sfc_main as default };
